import { render, staticRenderFns } from "./LocalizarFornecedor.vue?vue&type=template&id=1f13f0d4&scoped=true"
import script from "./LocalizarFornecedor.vue?vue&type=script&lang=js"
export * from "./LocalizarFornecedor.vue?vue&type=script&lang=js"
import style0 from "./LocalizarFornecedor.vue?vue&type=style&index=0&id=1f13f0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f13f0d4",
  null
  
)

export default component.exports